import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { IPlacementsMedia } from 'features/PlacementsStatus/types';
import { Statuses } from 'consts';

interface MediaState {
  loading: boolean;
  media: IPlacementsMedia[] | undefined;
}

const initialState: MediaState = {
  loading: false,
  media: undefined,
};

const reset: CaseReducer<MediaState> = () => initialState;

const setMedia: CaseReducer<MediaState, PayloadAction<IPlacementsMedia[]>> = (state, action) => {
  state.media = action.payload;
};

export const placementsMediaSlice = createSlice({
  name: 'placementsMedia',
  initialState,
  reducers: {
    loading: loading as IReducer<MediaState, boolean>,
    setMedia,
    reset,
  },
});

const {
  loading: setLoading,
  setMedia: setMediaData,
  reset: setReset,
} = placementsMediaSlice.actions;

export const getMedia =
  ({
    placementId,
    mediaStatus,
    subtype,
  }: {
    placementId: number;
    mediaStatus: Statuses;
    subtype?: string;
  }): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<IPlacementsMedia[]>(
      `/api/standards/placements/${placementId}/media/?status=${mediaStatus}`,
      { subtype: subtype },
    )
      .then(({ data }) => {
        dispatch(setMediaData(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setLoading, setReset };
